<template>
  <div>已跳转中瀚地图大屏页面，请在新页面查看</div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  created () {
    this.tiaoZhuan()
  },
  methods: {
    tiaoZhuan () {
      window.open(this.global.baseUrl + '/#/machiningDp')
    }
  }
}
</script>
<style>

</style>
